module.exports = __webpack_public_path__ + "img/834.de93d0e2.png";